import React from 'react';

const Spinner = () => (
  <div className="flex items-center justify-center h-screen">
    <img
      src="/logo-mobile.svg"
      alt="Loading..."
      className="h-16 w-16 animate-[spin_2s_linear_infinite]"
    />
  </div>
);


const SkeletonEventCard = () => (
  <div className="card w-full max-w-[350px] rounded-[16px] overflow-hidden bg-white dark:bg-[#1A1A1A] shadow-md animate-pulse">
    <div className="card-image relative w-full h-[220px] bg-gray-300 dark:bg-gray-700"></div>
    <div className="card-content p-5">
      {/* Category Tag */}
      <div className="h-6 w-16 bg-gray-300 dark:bg-gray-700 rounded-full mb-3"></div>

      {/* Event Title */}
      <div className="h-6 w-3/4 bg-gray-300 dark:bg-gray-700 rounded mb-2"></div>

      {/* Organizer */}
      <div className="flex items-center mb-4">
        <div className="w-8 h-8 rounded-full bg-gray-300 dark:bg-gray-700 mr-3"></div>
        <div className="h-4 w-1/2 bg-gray-300 dark:bg-gray-700 rounded"></div>
      </div>

      {/* Event Details (Time, Location) */}
      <div className="mb-4">
        <div className="flex items-center mb-2">
          <div className="w-4 h-4 bg-gray-300 dark:bg-gray-700 mr-2 rounded"></div>
          <div className="h-4 w-1/3 bg-gray-300 dark:bg-gray-700 rounded"></div>
        </div>
        <div className="flex items-center">
          <div className="w-4 h-4 bg-gray-300 dark:bg-gray-700 mr-2 rounded"></div>
          <div className="h-4 w-1/2 bg-gray-300 dark:bg-gray-700 rounded"></div>
        </div>
      </div>

      {/* Description */}
      <div className="h-4 w-full bg-gray-300 dark:bg-gray-700 rounded mb-5"></div>
      <div className="h-4 w-3/4 bg-gray-300 dark:bg-gray-700 rounded mb-5"></div>

      {/* Actions */}
      <div className="flex gap-3 mt-4">
        <div className="flex-1 h-10 bg-gray-300 dark:bg-gray-700 rounded-lg"></div>
        <div className="flex-1 h-10 bg-gray-300 dark:bg-gray-700 rounded-lg"></div>
      </div>
    </div>
  </div>
);

const SkeletonEventGrid = () => (
  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 justify-items-center lg:justify-items-end">
    {Array(3).fill(0).map((_, index) => (
      <SkeletonEventCard key={index} />
    ))}
  </div>
);

export { Spinner, SkeletonEventGrid };
